import { useGetFlexflowContractQuery } from 'src/shared/api/flexflow';
import { hasReachedAnnualConsumptionLimit } from '../utils/hasReachedAnnualConsumptionLimit';
import { useStyles } from './styles';
import { useMemo } from 'react';
import { updateStatusIfNeeded } from '../utils/updateStatusIfNeeded';

export const useEmployeeDetails = ({ payflowContractId }: { payflowContractId: number }) => {
  const { data, isLoading, error, isError } = useGetFlexflowContractQuery({ id: payflowContractId });
  const suspendedByLimit = hasReachedAnnualConsumptionLimit(data?.annualConsumptionPercentage);

  const dataWithStatus = useMemo(() => {
    if (!data) return null;
    return updateStatusIfNeeded({ data, suspendedByLimit });
  }, [data, suspendedByLimit]);

  const classes = useStyles();

  return {
    isLoading,
    error,
    isError,
    dataWithStatus,
    suspendedByLimit,
    classes
  };
};
